<template>
  <div>
    <ProposalSearch/>
    <ProposalTable/>
  </div>
</template>

<script>
import ProposalSearch  from '@/components/backend/proposal/ProposalSearch.vue'
import ProposalTable from '@/components/backend/proposal/ProposalTable.vue'

export default {
  name: 'ProposalList',
  components: {
    ProposalSearch,
    ProposalTable
  }
}
</script>

<style scoped>

</style>
